import { Camera, History, Search, Settings } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { Merk } from '../onderdelen/ui'
import { ga } from '../lib/router'
import { bakkenVan, laadWerk, useStaat } from '../lib/staat'

/* ===========================================================================
 *  Het startscherm
 *
 *  Vijf tegels, op de plek waar ze in Blue10 staan: Scannen, To-do (met het
 *  getal), Zoeken, Voorkeuren en Geschiedenis. Wie de app kent, hoeft niet
 *  te zoeken.
 *
 *  Het getal op To-do is alleen wat op JOUW naam staat (bakkenVan in
 *  lib/staat.ts): strenger dan de tegel in het dashboard, op verzoek van
 *  Casper. De gedeelde stapels staan in de To-do ernaast.
 * =========================================================================== */

export default function Start() {
  const ik = useStaat((s) => s.ik)
  const werk = useStaat((s) => s.werk)
  const laden = useStaat((s) => s.werkLaden)
  const fout = useStaat((s) => s.werkFout)

  useEffect(() => { void laadWerk() }, [])

  const aantal = useMemo(
    () => (ik && werk ? bakkenVan(werk.bonnen, ik).mij.length : null),
    [ik, werk])

  return (
    <div className="start">
      <div className="start-band">
        <Merk />
      </div>

      <section className="start-groet">
        <h1>Hoi {ik?.ik.naam ?? ''}</h1>
        <p>Je bent ingelogd op: Truckwash 1 Group B.V.</p>
      </section>

      <nav className="tegels" aria-label="Menu">
        <Tegel kleur="lucht" label="Scannen" opKlik={() => ga('/scannen')} uit={ik ? !ik.mag.scannen : false}>
          <Camera size={86} strokeWidth={1.6} />
        </Tegel>
        <Tegel kleur="rood" label="To-do" opKlik={() => ga('/todo')}>
          <span className="tegel-getal">
            {aantal === null ? (fout ? '!' : laden ? '…' : '') : aantal.toLocaleString('nl-NL')}
          </span>
        </Tegel>
        <Tegel kleur="oranje" label="Zoeken" opKlik={() => ga('/zoeken')}>
          <Search size={84} strokeWidth={1.8} />
        </Tegel>
        <Tegel kleur="grijs" label="Voorkeuren" opKlik={() => ga('/voorkeuren')}>
          <Settings size={88} strokeWidth={1.5} />
        </Tegel>
        <span className="tegel-gat" aria-hidden="true" />
        <Tegel kleur="blauw" label="Geschiedenis" opKlik={() => ga('/geschiedenis')}>
          <History size={86} strokeWidth={1.6} />
        </Tegel>
      </nav>
    </div>
  )
}

function Tegel({ kleur, label, opKlik, children, uit }: {
  kleur: string; label: string; opKlik: () => void; children: React.ReactNode; uit?: boolean
}) {
  return (
    <button className="tegel" onClick={opKlik} disabled={uit} title={uit ? 'Scannen staat voor jouw account niet aan.' : undefined}>
      <span className={`tegel-vlak tegel-${kleur}`}>{children}</span>
      <span className="tegel-label">{label}</span>
    </button>
  )
}
